import { agreementSearchSchema } from '@/features/agreements/filter-agreements/model/agreementSearch'
import { internshipDetailsSearchSchema } from '@/features/internships/view-internship/model/internshipDetailsSearch'

export const internshipDetailsPageSearchSchema = internshipDetailsSearchSchema.extend({
  agreements: agreementSearchSchema.optional().catch(undefined),
})
